// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VYbToR4TklOIhf4X45MY {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: relative;
  /* padding: 20px; */
  color: black;
  font-family: var(--qa-fontFamily, inherit);
}

.pNnExGnKVPGX2BE9iCvu {
  width: 100%;
  max-width: 600px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--qa-backgroundColor);
  border-radius: 12.5px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  border: 1px solid #eaeaea;
  padding: 15px 15px 5px 15px;
  gap: 15px;
}

.szuFUBU6q9dhb4cgxfRO {
  position: relative;
  /* margin-bottom: 2rem; */
  display: flex;
  flex-direction: row;
  gap: 1rem;
  transition: transform 0.3s ease-out;
  touch-action: pan-x;
  user-select: none;
  perspective: 1000px;
  transform-origin: bottom center;
}

.rzWJOuFQPvQkqOYGuNgq {
  font-size: 10px;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color:#b7b7b7;
  text-decoration: none;
}

.Bc5L85UldKAeCqrfC3I3 {
  color: #83aae5;
  text-decoration: none;
}

.QPwDMezVtL1cg3yqzCSV {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0;
  font-size: 10px;
  color: #cfcfcf;
}

.ebeq0DgplDN7eSfSh6Bc {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  background-color: rgb(150, 192, 226);
  padding: 10px;
  border-radius: 10px;
  /* Add any additional styling for the feedback container */
}

/* @media (min-width: 769px) {
  .focusSection {
    padding-left: 0;
  }
} */

@media (max-width: 768px) {
  /* .focusSection {
    padding: 0 15px;
  } */
}

.OSLSbeU1S9ODYCWGmDQy {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-grow: 1;
  overflow-x: visible;
  /* padding: 10px 0; */
  /* margin: 10px 0; */
}

.ifFwZE6Jt3k0bESjk51w {
    opacity: 1;
    transform: translateY(0);
    transition: all 0.3s ease-out;
    border-radius: 25px;
  }
  
  .X78ABdkLi4FnclMjO3sg {
    animation: JJpcPX2Mrwu7you6X26g 1.5s cubic-bezier(0.34, 1.56, 0.64, 1), 
               qRjAd46cRM9rMvIur8dM 0.2s ease-in-out 1.5s;
  }
  
  @keyframes qRjAd46cRM9rMvIur8dM {
    0% {
      box-shadow: 0 0 20px color-mix(in srgb, var(--qa-questionGlowColor), transparent 80%);
    }
    
    50% {
      box-shadow: 0 0 10px color-mix(in srgb, var(--qa-questionGlowColor), transparent 90%);
    }
    
    100% {
      box-shadow: 0 0 0 color-mix(in srgb, var(--qa-questionGlowColor), transparent 100%);
    }
  }
  
  @keyframes JJpcPX2Mrwu7you6X26g {
    0% {
        opacity: 0;
        transform: scale(0.95) translateY(-10px);
        box-shadow: 0 0 0 color-mix(in srgb, var(--qa-questionGlowColor), transparent 100%);
    }
    
    40% {
        opacity: 0.8;
        transform: scale(1.02) translateY(0);
        box-shadow: 0 0 20px color-mix(in srgb, var(--qa-questionGlowColor), transparent 80%);
    }
    
    100% {
        opacity: 1;
        transform: scale(1) translateY(0);
        box-shadow: 0 0 20px color-mix(in srgb, var(--qa-questionGlowColor), transparent 80%);
    }
}

.AcCb6gfXgRUJ2y6Z00ux {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;

}

.plgeWGFkzq3xg5n_DoTm {
  transform: translateX(-10px) rotateY(-5deg);
  opacity: 0.9;
}

.PUhvmZI9Or0IrY1va1u3 {
  transform: translateX(10px) rotateY(5deg);
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./app/components/MainScreen/MainScreen.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,qBAAqB;EACrB,8CAA8C;EAC9C,yBAAyB;EACzB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;;;;GAIG;;AAEH;EACE;;KAEG;AACL;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;IACE;yDAC0C;EAC5C;;EAEA;IACE;MACE,qFAAqF;IACvF;;IAEA;MACE,qFAAqF;IACvF;;IAEA;MACE,mFAAmF;IACrF;EACF;;EAEA;IACE;QACI,UAAU;QACV,wCAAwC;QACxC,mFAAmF;IACvF;;IAEA;QACI,YAAY;QACZ,oCAAoC;QACpC,qFAAqF;IACzF;;IAEA;QACI,UAAU;QACV,iCAAiC;QACjC,qFAAqF;IACzF;AACJ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,QAAQ;;AAEV;;AAEA;EACE,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd","sourcesContent":[".mainScreenContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  position: relative;\n  /* padding: 20px; */\n  color: black;\n  font-family: var(--qa-fontFamily, inherit);\n}\n\n.contentContainer {\n  width: 100%;\n  max-width: 600px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: var(--qa-backgroundColor);\n  border-radius: 12.5px;\n  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */\n  border: 1px solid #eaeaea;\n  padding: 15px 15px 5px 15px;\n  gap: 15px;\n}\n\n.focusSection {\n  position: relative;\n  /* margin-bottom: 2rem; */\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  transition: transform 0.3s ease-out;\n  touch-action: pan-x;\n  user-select: none;\n  perspective: 1000px;\n  transform-origin: bottom center;\n}\n\n.footer {\n  font-size: 10px;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color:#b7b7b7;\n  text-decoration: none;\n}\n\n.trusteLogo {\n  color: #83aae5;\n  text-decoration: none;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n  padding: 0;\n  font-size: 10px;\n  color: #cfcfcf;\n}\n\n.feedbackContainer {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10;\n  background-color: rgb(150, 192, 226);\n  padding: 10px;\n  border-radius: 10px;\n  /* Add any additional styling for the feedback container */\n}\n\n/* @media (min-width: 769px) {\n  .focusSection {\n    padding-left: 0;\n  }\n} */\n\n@media (max-width: 768px) {\n  /* .focusSection {\n    padding: 0 15px;\n  } */\n}\n\n.questionsList {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  flex-grow: 1;\n  overflow-x: visible;\n  /* padding: 10px 0; */\n  /* margin: 10px 0; */\n}\n\n.questionItem {\n    opacity: 1;\n    transform: translateY(0);\n    transition: all 0.3s ease-out;\n    border-radius: 25px;\n  }\n  \n  .slideIn {\n    animation: coolEntrance 1.5s cubic-bezier(0.34, 1.56, 0.64, 1), \n               afterGlow 0.2s ease-in-out 1.5s;\n  }\n  \n  @keyframes afterGlow {\n    0% {\n      box-shadow: 0 0 20px color-mix(in srgb, var(--qa-questionGlowColor), transparent 80%);\n    }\n    \n    50% {\n      box-shadow: 0 0 10px color-mix(in srgb, var(--qa-questionGlowColor), transparent 90%);\n    }\n    \n    100% {\n      box-shadow: 0 0 0 color-mix(in srgb, var(--qa-questionGlowColor), transparent 100%);\n    }\n  }\n  \n  @keyframes coolEntrance {\n    0% {\n        opacity: 0;\n        transform: scale(0.95) translateY(-10px);\n        box-shadow: 0 0 0 color-mix(in srgb, var(--qa-questionGlowColor), transparent 100%);\n    }\n    \n    40% {\n        opacity: 0.8;\n        transform: scale(1.02) translateY(0);\n        box-shadow: 0 0 20px color-mix(in srgb, var(--qa-questionGlowColor), transparent 80%);\n    }\n    \n    100% {\n        opacity: 1;\n        transform: scale(1) translateY(0);\n        box-shadow: 0 0 20px color-mix(in srgb, var(--qa-questionGlowColor), transparent 80%);\n    }\n}\n\n.focusContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 8px;\n\n}\n\n.swipingLeft {\n  transform: translateX(-10px) rotateY(-5deg);\n  opacity: 0.9;\n}\n\n.swipingRight {\n  transform: translateX(10px) rotateY(5deg);\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
export var mainScreenContainer = `VYbToR4TklOIhf4X45MY`;
export var contentContainer = `pNnExGnKVPGX2BE9iCvu`;
export var focusSection = `szuFUBU6q9dhb4cgxfRO`;
export var footer = `rzWJOuFQPvQkqOYGuNgq`;
export var trusteLogo = `Bc5L85UldKAeCqrfC3I3`;
export var header = `QPwDMezVtL1cg3yqzCSV`;
export var feedbackContainer = `ebeq0DgplDN7eSfSh6Bc`;
export var questionsList = `OSLSbeU1S9ODYCWGmDQy`;
export var questionItem = `ifFwZE6Jt3k0bESjk51w`;
export var slideIn = `X78ABdkLi4FnclMjO3sg`;
export var coolEntrance = `JJpcPX2Mrwu7you6X26g`;
export var afterGlow = `qRjAd46cRM9rMvIur8dM`;
export var focusContainer = `AcCb6gfXgRUJ2y6Z00ux`;
export var swipingLeft = `plgeWGFkzq3xg5n_DoTm`;
export var swipingRight = `PUhvmZI9Or0IrY1va1u3`;
export default ___CSS_LOADER_EXPORT___;
